import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./youtube.css";

const Youtube = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [bookmarkedVideos, setBookmarkedVideos] = useState([]);
  const [showBookmarks, setShowBookmarks] = useState(false);

  const videos = [
    {
      id: "1",
      title: "How to Start a Business in 2024",
      videoId: "U3wUqrHcowc",
      category: "Business Basics",
      description: "Learn the essential steps to start your business in 2024, from ideation to execution.",
      views: "2.5M",
      tags: ["Business", "Startup", "Entrepreneurship"],
      thumbnail: "https://img.youtube.com/vi/U3wUqrHcowc/maxresdefault.jpg"
    },
    {
      id: "2",
      title: "The Psychology of Money",
      videoId: "Gg8_TA7U0Uw",
      category: "Finance",
      description: "Understanding the psychological aspects of money management and wealth building.",
      views: "1.8M",
      tags: ["Finance", "Psychology", "Wealth"],
      thumbnail: "https://img.youtube.com/vi/Gg8_TA7U0Uw/maxresdefault.jpg"
    },
    {
      id: "3",
      title: "Digital Marketing Masterclass 2024",
      videoId: "bixR-KIJKYM",
      category: "Marketing",
      description: "Comprehensive guide to digital marketing strategies for modern businesses.",
      views: "3.2M",
      tags: ["Marketing", "Digital", "Strategy"],
      thumbnail: "https://img.youtube.com/vi/bixR-KIJKYM/maxresdefault.jpg"
    },
    {
      id: "4",
      title: "Building a Personal Brand",
      videoId: "hFZFjoX2cGg",
      category: "Personal Development",
      description: "Learn how to build and maintain a strong personal brand in the digital age.",
      views: "1.5M",
      tags: ["Branding", "Personal Brand", "Social Media"],
      thumbnail: "https://img.youtube.com/vi/hFZFjoX2cGg/maxresdefault.jpg"
    },
    {
      id: "5",
      title: "Startup Funding Strategies",
      videoId: "SxDD4X3qsPk",
      category: "Finance",
      description: "Explore different ways to fund your startup and attract investors.",
      views: "950K",
      tags: ["Funding", "Investors", "Startup"],
      thumbnail: "https://img.youtube.com/vi/SxDD4X3qsPk/maxresdefault.jpg"
    },
    {
      id: "6",
      title: "E-commerce Success Secrets",
      videoId: "YQwDm1KQyXc",
      category: "Business Basics",
      description: "Master the art of running a successful e-commerce business.",
      views: "1.2M",
      tags: ["E-commerce", "Online Business", "Retail"],
      thumbnail: "https://img.youtube.com/vi/YQwDm1KQyXc/maxresdefault.jpg"
    },
    {
      id: "7",
      title: "Social Media Marketing 2024",
      videoId: "lM7mJwGgqXk",
      category: "Marketing",
      description: "Latest strategies and trends in social media marketing.",
      views: "2.1M",
      tags: ["Social Media", "Marketing", "Strategy"],
      thumbnail: "https://img.youtube.com/vi/lM7mJwGgqXk/maxresdefault.jpg"
    },
    {
      id: "8",
      title: "Business Model Canvas Explained",
      videoId: "QoAOzMTLP5s",
      category: "Business Basics",
      description: "Learn how to create and use the Business Model Canvas effectively.",
      views: "780K",
      tags: ["Business Model", "Strategy", "Planning"],
      thumbnail: "https://img.youtube.com/vi/QoAOzMTLP5s/maxresdefault.jpg"
    },
    {
      id: "9",
      title: "Leadership Skills for Entrepreneurs",
      videoId: "XPdl_6copJA",
      category: "Personal Development",
      description: "Essential leadership skills every entrepreneur should develop.",
      views: "1.3M",
      tags: ["Leadership", "Management", "Skills"],
      thumbnail: "https://img.youtube.com/vi/XPdl_6copJA/maxresdefault.jpg"
    },
    {
      id: "10",
      title: "Product Development Process",
      videoId: "UQPiV5DfqXk",
      category: "Business Basics",
      description: "Step-by-step guide to developing and launching successful products.",
      views: "890K",
      tags: ["Product Development", "Innovation", "Launch"],
      thumbnail: "https://img.youtube.com/vi/UQPiV5DfqXk/maxresdefault.jpg"
    },
    {
      id: "11",
      title: "Customer Acquisition Strategies",
      videoId: "YQwDm1KQyXc",
      category: "Marketing",
      description: "Effective strategies to acquire and retain customers.",
      views: "1.1M",
      tags: ["Marketing", "Customers", "Growth"],
      thumbnail: "https://img.youtube.com/vi/YQwDm1KQyXc/maxresdefault.jpg"
    },
    {
      id: "12",
      title: "Business Analytics Fundamentals",
      videoId: "bixR-KIJKYM",
      category: "Finance",
      description: "Learn how to use data analytics to make better business decisions.",
      views: "750K",
      tags: ["Analytics", "Data", "Business Intelligence"],
      thumbnail: "https://img.youtube.com/vi/bixR-KIJKYM/maxresdefault.jpg"
    }
  ];

  const courses = [
    {
      id: "1",
      title: "Complete Business Strategy Course",
      instructor: "John Smith",
      platform: "Udemy",
      thumbnail: "https://img.youtube.com/vi/U3wUqrHcowc/maxresdefault.jpg",
      tags: ["Strategy", "Business", "Planning"],
      link: "https://www.udemy.com/course/business-strategy/"
    },
    {
      id: "2",
      title: "Digital Marketing Mastery",
      instructor: "Sarah Johnson",
      platform: "Coursera",
      thumbnail: "https://img.youtube.com/vi/bixR-KIJKYM/maxresdefault.jpg",
      tags: ["Marketing", "Digital", "Social Media"],
      link: "https://www.coursera.org/learn/digital-marketing"
    },
    {
      id: "3",
      title: "Entrepreneurship Fundamentals",
      instructor: "Michael Brown",
      platform: "edX",
      thumbnail: "https://img.youtube.com/vi/hFZFjoX2cGg/maxresdefault.jpg",
      tags: ["Entrepreneurship", "Business", "Startup"],
      link: "https://www.edx.org/learn/entrepreneurship"
    }
  ];

  const categories = ["All", "Business Basics", "Marketing", "Finance", "Personal Development"];

  const filteredVideos = videos.filter(video => {
    const matchesCategory = selectedCategory === "All" || video.category === selectedCategory;
    const matchesSearch = video.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         video.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         video.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const filteredCourses = courses.filter(course => {
    const matchesCategory = selectedCategory === "All" || course.tags.includes(selectedCategory);
    const matchesSearch = course.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         course.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const toggleBookmark = (videoId) => {
    setBookmarkedVideos(prev => 
      prev.includes(videoId)
        ? prev.filter(id => id !== videoId)
        : [...prev, videoId]
    );
  };

  const displayVideos = showBookmarks
    ? videos.filter(video => bookmarkedVideos.includes(video.id))
    : filteredVideos;

  return (
    <div className="mentorship-container">
      <h1 className="mentorship-title">Entrepreneurial Mentorship</h1>
      
      <div className="search-filter-container">
        <div className="search-bar">
          <input
            type="text"
            className="search-input"
            placeholder="Search videos and courses..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button
            className={`bookmark-toggle ${showBookmarks ? 'active' : ''}`}
            onClick={() => setShowBookmarks(!showBookmarks)}
          >
            {showBookmarks ? 'Show All' : 'Show Bookmarks'}
          </button>
        </div>
        
        <div className="category-filters">
          {categories.map(category => (
            <button
              key={category}
              className={`category-button ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="content-sections">
        <section className="videos-section">
          <h2>Featured Videos</h2>
          <div className="videos-grid">
            <AnimatePresence>
              {displayVideos.map(video => (
                <motion.div
                  key={video.id}
                  className="video-card"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="video-thumbnail">
                    <img src={video.thumbnail} alt={video.title} />
                    <div className="video-tags">
                      {video.tags.map(tag => (
                        <span key={tag} className="tag">{tag}</span>
                      ))}
                    </div>
                    <button
                      className={`bookmark-button ${bookmarkedVideos.includes(video.id) ? 'bookmarked' : ''}`}
                      onClick={() => toggleBookmark(video.id)}
                    >
                      {bookmarkedVideos.includes(video.id) ? '★' : '☆'}
                    </button>
                  </div>
                  <div className="video-info">
                    <h3>{video.title}</h3>
                    <p>{video.description}</p>
                    <div className="video-meta">
                      <span>{video.views} views</span>
                      <span>{video.category}</span>
                    </div>
                    <iframe
                      width="100%"
                      height="200"
                      src={`https://www.youtube.com/embed/${video.videoId}`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </section>

        <section className="courses-section">
          <h2>Recommended Courses</h2>
          <div className="courses-grid">
            <AnimatePresence>
              {filteredCourses.map(course => (
                <motion.div
                  key={course.id}
                  className="course-card"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="course-thumbnail">
                    <img src={course.thumbnail} alt={course.title} />
                    <span className="course-platform">{course.platform}</span>
                  </div>
                  <div className="course-info">
                    <h3>{course.title}</h3>
                    <p className="course-instructor">By {course.instructor}</p>
                    <div className="course-tags">
                      {course.tags.map(tag => (
                        <span key={tag} className="tag">{tag}</span>
                      ))}
                    </div>
                    <a href={course.link} target="_blank" rel="noopener noreferrer" className="view-course-button">
                      View Course
                    </a>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Youtube;
